// ** React Imports
import { useEffect, useState } from 'react'
import { useRTL } from '@hooks/useRTL'
import '@styles/base/core/menu/menu-types/horizontal-menu.scss'

const BlankLayout = ({ children, ...rest }) => {

  // ** States
  const [isMounted, setIsMounted] = useState(false)
  const [isRtl, setIsRtl] = useRTL()

  //** ComponentDidMount
  useEffect(() => {
    setIsMounted(true)
    return () => setIsMounted(false)
  }, [])

  if (!isMounted) {
    return null
  }

  return (
    <div className='blank-page'>
      <div className='app-content content'>
        <div className='content-wrapper'>
          <div className='content-body'>{children}</div>
        </div>
      </div>
    </div>
  )
}

export default BlankLayout
